import Papa, {ParseResult} from 'papaparse';

export interface ParseCsvWithPapaOptions<T> extends Omit<Papa.ParseLocalConfig<T>, 'complete'> {
  validate?: (data: any) => T;
}

/**
 * run papa.parse in async way
 * @param csvFile
 * @param options
 * @returns
 */
export async function parseCsvWithPapa<T>(csvFile: File, options: ParseCsvWithPapaOptions<T>): Promise<ParseResult<T>> {
  return new Promise((resolve, reject) => {
    Papa.parse(csvFile, {
      ...options,
      complete: (result) => {
        const output = {...result, ...(options.validate ? {data: result.data.map(options.validate)} : {})};
        resolve(output as ParseResult<T>);
      },
      error: (err) => {
        reject(err);
      },
    });
  });
}
